import React from 'react'
import PropTypes from 'prop-types'
import { Col, Descriptions, Modal, Row } from 'antd'
import {
  formatCountAndRatio,
  formatMetricCount,
  formatMetricPercent,
} from '../../../utils'
import { renderValidationMetricItem } from './render-validation-metric'
import ValidationFieldMetricsTable from './validation-field-metrics-table'
import ScrapingMenuValidationStatus from './scraping-menu-validation-status'

const ScrapingMenuValidationModal = ({
  isModalOpen,
  scrapingTestCaseResult,
  closeModal,
}) => {
  const metrics = scrapingTestCaseResult?.validationMetrics || {}
  const menu = metrics.menu || {}

  return (
    <Modal
      width="95vw"
      bodyStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
      visible={isModalOpen}
      title={`Menu validation details: ${
        scrapingTestCaseResult?.scrapingTestCase?.menuId || 'N/A'
      }`}
      footer={null}
      onCancel={closeModal}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12} xl={8}>
          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label="Validation status">
              <ScrapingMenuValidationStatus
                status={scrapingTestCaseResult?.validationStatus}
              />
            </Descriptions.Item>
            {renderValidationMetricItem(
              'Overall validation score',
              formatMetricPercent(menu.validationScore),
            )}
            {renderValidationMetricItem(
              'F1 score',
              formatMetricPercent(menu.f1),
            )}
            {renderValidationMetricItem(
              'Menu average total similarity',
              formatMetricPercent(menu.totalSimilarity),
            )}
            {renderValidationMetricItem(
              'Menu average identity similarity',
              formatMetricPercent(menu.identitySimilarity),
            )}
            {renderValidationMetricItem(
              'Menu average content similarity',
              formatMetricPercent(menu.contentSimilarity),
            )}
            {renderValidationMetricItem(
              'Menu-title average total similarity',
              formatMetricPercent(metrics.menuTitles?.totalSimilarity),
            )}
            {renderValidationMetricItem(
              'Dish average total similarity',
              formatMetricPercent(metrics.dishes?.totalSimilarity),
            )}
          </Descriptions>
        </Col>
        <Col xs={24} md={12} xl={8}>
          <Descriptions bordered size="small" column={1}>
            {renderValidationMetricItem(
              'Matched items (ratio)',
              formatCountAndRatio(menu.matchedCount, menu.recall),
            )}
            {renderValidationMetricItem(
              'Exact items (rate)',
              formatCountAndRatio(menu.exactCount, menu.exactMatchRate),
            )}
            {renderValidationMetricItem(
              'Similar items (rate)',
              formatCountAndRatio(menu.similarCount, menu.similarMatchRate),
            )}
            {renderValidationMetricItem(
              'Missing items (ratio)',
              formatCountAndRatio(menu.missingCount, menu.missingRatio),
            )}
            {renderValidationMetricItem(
              'New items (ratio)',
              formatCountAndRatio(menu.newCount, menu.newRatio),
            )}
          </Descriptions>
        </Col>
        <Col xs={24} md={12} xl={8}>
          <Descriptions bordered size="small" column={1}>
            {renderValidationMetricItem(
              'Total ideal items',
              formatMetricCount(menu.idealCount),
            )}
            {renderValidationMetricItem(
              'Total current items',
              formatMetricCount(menu.currentCount),
            )}
          </Descriptions>
        </Col>
      </Row>
      <div style={{ marginTop: 16 }}>
        <ValidationFieldMetricsTable metrics={metrics} />
      </div>
    </Modal>
  )
}

ScrapingMenuValidationModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  scrapingTestCaseResult: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
}

ScrapingMenuValidationModal.defaultProps = {
  scrapingTestCaseResult: undefined,
}

export default ScrapingMenuValidationModal
